export default "__VITE_ASSET__CbFrlz5j__"